import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { useI18n } from '@/hooks/useI18n';
import { revokeItineraryQuote, revokeQuoteErrorKey } from '@/services/itinerary.service';
import { PAYMENT_PLAN_QUERY_KEY } from './usePaymentPlan';
import { PAYMENTS_DASHBOARD_QUERY_KEY } from '@/lib/payments/models/payments-dashboard.model';

/**
 * Ritira il preventivo riportandolo in bozza.
 *
 * `onRevoked` esiste perche' l'itinerario nel builder non vive in react-query ma nello stato
 * locale della pagina: invalidare le query non basta a far ricomparire i campi editabili.
 */
export const useRevokeQuote = (itineraryId?: string, onRevoked?: () => void) => {
    const queryClient = useQueryClient();
    const { toast } = useToast();
    const { t } = useI18n();

    return useMutation({
        mutationFn: () => revokeItineraryQuote(itineraryId as string),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [PAYMENT_PLAN_QUERY_KEY, itineraryId ?? null] });
            // Lo stato dell'itinerario e' una colonna della dashboard pagamenti: senza questa
            // resterebbe "inviato" fino alla scadenza della cache.
            queryClient.invalidateQueries({ queryKey: [PAYMENTS_DASHBOARD_QUERY_KEY] });
            toast({ title: t('builder.pricingLock.revoked') });
            onRevoked?.();
        },
        onError: (error) => {
            toast({ title: t(revokeQuoteErrorKey(error)), variant: 'destructive' });
        },
    });
};
